<template>
    <administrative>
        
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="faculties" :searchlink="route('administrative.faculty.search')" :action="{'text':'Add Faculty','url':route('administrative.faculty.create')}" :canCreate="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Create Faculty')" :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Faculty')">
                <template #name="data">
                    {{data.item.first_name}} {{data.item.last_name}}
                </template>
                <template #type="data">
                    {{data.item.type.toUpperCase()}}
                </template>
                <template #action="data">
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'Edit Faculty')" :href="route('administrative.faculty.edit',data.item.id)" class="mr-2" >Edit</button-link>
                    <button-link v-if="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Faculty')" :href="route('administrative.faculty.view',data.item.id)" >View</button-link>
                </template>
                <template #status="data">
                    {{data.item.status?'Active':'Inactive'}}
                </template>
            </breeze-table>
        </div>
    </administrative>
</template>

<script>
    import Administrative from '@/Pages/Administrative/Administrative'
    import BreezeTable from '@/Components/Table'
    import ButtonLink from '@/Components/ButtonLink'

    export default {
        components: {
            Administrative,
            BreezeTable,
            ButtonLink
        },
        props:['faculties'],
        data(){
            return{
                fields:[{'key':'name','label':'Name'},{'key':'mobile','label':'Mobile'},{'key':'email','label':'Email'},{'key':'type','label':'Type'},{'key':'city','label':'City'},{'key':'status','label':'Status'},{'key':'action','label':'Action'}],
            }
        }
    }
</script>
